export const notBeEmptyString = (
  inputName: string
): ((value) => boolean | string) => {
  return (value): boolean | string => {
    return !!value.trim().length || `${inputName} is required`;
  };
};
